var exports = {
  "container": "xf0b3b88a--401c7f--container",
  "container-horizontal": "xf0b3b88a--401c7f--container-horizontal",
  "user-avatar": "xf0b3b88a--401c7f--user-avatar",
  "user-info-container": "xf0b3b88a--401c7f--user-info-container",
  "user-info-horizontal-container": "xf0b3b88a--401c7f--user-info-horizontal-container",
  "user-info--horizontal": "xf0b3b88a--401c7f--user-info--horizontal",
  "user-info-name": "xf0b3b88a--401c7f--user-info-name",
  "user-info-name--horizontal": "xf0b3b88a--401c7f--user-info-name--horizontal",
  "user-info-company": "xf0b3b88a--401c7f--user-info-company",
  "user-info-badges": "xf0b3b88a--401c7f--user-info-badges",
  "user-info-badges--horizontal": "xf0b3b88a--401c7f--user-info-badges--horizontal",
  "user-info-badge": "xf0b3b88a--401c7f--user-info-badge",
  "user-info-badge--horizontal": "xf0b3b88a--401c7f--user-info-badge--horizontal",
  "honest-work": "xf0b3b88a--401c7f--honest-work",
  "user-info-text-badge": "xf0b3b88a--401c7f--user-info-text-badge",
  "user-info-text-badge--green": "xf0b3b88a--401c7f--user-info-text-badge--green",
  "green-light": "xf0b3b88a--401c7f--green-light",
};

module.exports = exports;
